export function getInstanceSelector(instanceId) {
    return `[data-testid='instance-${instanceId}']`;
}
export function isDialogOpen(instanceId) {
    return !!document.querySelector(`${getInstanceSelector(instanceId)} [role='dialog']`);
}
export function isDrawerOpen(instanceId) {
    return !!document.querySelector(`${getInstanceSelector(instanceId)} [aria-label='drawer']`);
}
